import { buildClient as buildCmaClient } from '@datocms/cma-client-browser';
import { GraphQLClient } from 'graphql-request';

import { getDatocmsEnvironment, getDatocmsReadToken } from './spaCredentials';

import type { ClientConfigOptions } from '@datocms/cma-client-browser';
import type { RequestDocument, Variables } from 'graphql-request';

type Headers = {
  [key: string]: string;
};

export function createDatoClient(config: ClientConfigOptions) {
  return buildCmaClient({
    ...config,
    baseUrl: '/datocms-cma',
  });
}

export function createGQLClient({
  includeDrafts,
  excludeInvalid,
  environment,
  authToken,
}: {
  includeDrafts?: boolean;
  excludeInvalid?: boolean;
  environment?: string;
  authToken: string;
}) {
  const headers: Headers = {
    authorization: `Bearer ${authToken}`,
  };

  if (includeDrafts) {
    headers['X-Include-Drafts'] = 'true';
  }

  if (excludeInvalid) {
    headers['X-Exclude-Invalid'] = 'true';
  }

  // Fall back to the env supplied by the arbor-v1 subscription-token
  // response when the caller didn't pass one (SPA routes lacking the
  // ?env=… query param). DatoCMS returns 401 INSUFFICIENT_PERMISSIONS
  // for protected models when the header is omitted on a multi-env
  // project.
  const resolvedEnvironment = environment || getDatocmsEnvironment();
  if (resolvedEnvironment) {
    headers['X-Environment'] = resolvedEnvironment;
  }

  return new GraphQLClient('/datocms-gql', { headers });
}

export function request({
  query,
  variables,
  includeDrafts,
  excludeInvalid,
  environment,
}: {
  query: RequestDocument;
  variables?: Variables;
  includeDrafts?: boolean;
  excludeInvalid?: boolean;
  environment?: string;
}) {
  const client = createGQLClient({
    includeDrafts,
    excludeInvalid,
    environment,
    authToken: getDatocmsReadToken(),
  });
  return client.request(query, variables);
}
